// Existing server-cleaned HTML stays intact; add safe links in text nodes only.
export function linkifyHtml(html) {
  const doc = new DOMParser().parseFromString(html || '', 'text/html');
  const walker = doc.createTreeWalker(doc.body, NodeFilter.SHOW_TEXT), nodes = [];
  while (walker.nextNode()) if (!walker.currentNode.parentElement.closest('a,pre,code,script,style')) nodes.push(walker.currentNode);
  for (const node of nodes) {
    const pattern = /(?:https?:\/\/|www\.)[^\s<>]+/gi, text = node.textContent;
    const matches = [...text.matchAll(pattern)]; if (!matches.length) continue;
    const fragment = doc.createDocumentFragment(); let start = 0;
    for (const match of matches) {
      const value = match[0].replace(/[.,;!?)]*$/, '');
      fragment.append(doc.createTextNode(text.slice(start, match.index)));
      const a = doc.createElement('a'); a.textContent = value; a.href = /^www\./i.test(value) ? 'https://' + value : value;
      a.target = '_blank'; a.rel = 'noopener noreferrer'; fragment.append(a);
      start = match.index + value.length;
    }
    fragment.append(doc.createTextNode(text.slice(start))); node.replaceWith(fragment);
  }
  doc.body.querySelectorAll('a').forEach(a => { a.target = '_blank'; a.rel = 'noopener noreferrer'; });
  return doc.body.innerHTML;
}
